import React from "react";
import Select from "react-select";
import { Controller } from "react-hook-form";
import { RenderKilogramo } from "../../../../../../Utils/renderField/renderReadField";
import { NumberField } from "../../../../../../Utils/renderField/fieldsHookForms";

export const PacasSecadora = ({ cierreTurnoForm }) => {
    const {
        formControl,
        formErrors,
        hayPacasEnSecadora,
        pesoPacasSecadora,
        productosTrabajados,
    } = cierreTurnoForm;

    const cardClassName = "my-3 p-3 border-gray rounded-xl gap-1rem";

    if (!hayPacasEnSecadora) {
        return (
            <div className={`${cardClassName} align-items-center`}>
                <div className="d-flex align-items-center gap-1rem justify-content-end">
                    <h5 className="mb-1 text-right text-nowrap">
                        ¿Hay pacas en secadora?
                    </h5>

                    <div style={{ minWidth: "200px" }}>
                        <Controller
                            name="pacas_secadora"
                            control={formControl}
                            rules={{
                                required: "Este campo es obligatorio",
                            }}
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    className="react-select-container"
                                    backspaceRemovesValue={false}
                                    isSearchable
                                    options={[
                                        {
                                            value: true,
                                            label: "Sí",
                                        },
                                        {
                                            value: false,
                                            label: "No",
                                        },
                                    ]}
                                    placeholder="Seleccionar"
                                />
                            )}
                        />
                        {formErrors.pacas_secadora && (
                            <small className="text-danger">
                                {formErrors.pacas_secadora.message}
                            </small>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={`formulario-fields-column ${cardClassName}`}>
            <h5 className="mb-1">Pacas en secadora</h5>

            <div className="formulario-fields-row gap-1rem my-0">
                <div className="formulario-field">
                    <label htmlFor="pacas_secadora" className="text-nowrap">
                        ¿Hay pacas en secadora?
                    </label>

                    <Controller
                        name="pacas_secadora"
                        control={formControl}
                        rules={{
                            required: "Este campo es obligatorio",
                        }}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className="react-select-container"
                                backspaceRemovesValue={false}
                                isSearchable
                                options={[
                                    {
                                        value: true,
                                        label: "Sí",
                                    },
                                    {
                                        value: false,
                                        label: "No",
                                    },
                                ]}
                                placeholder="Seleccionar"
                            />
                        )}
                    />
                    {formErrors.pacas_secadora && (
                        <small className="text-danger">
                            {formErrors.pacas_secadora.message}
                        </small>
                    )}
                </div>

                <div className="formulario-field">
                    <label className="text-nowrap">Producto</label>
                    <Controller
                        name="orden_produccion_pacas_secadora"
                        control={formControl}
                        rules={{
                            required: "Este campo es obligatorio",
                        }}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className="react-select-container"
                                backspaceRemovesValue={false}
                                isSearchable
                                options={productosTrabajados}
                                getOptionValue={(option) =>
                                    option.orden_produccion_id
                                }
                                getOptionLabel={(option) =>
                                    option.padre_producto_terminado_nombre
                                        ? `${option.padre_producto_terminado_nombre} - ${option.producto_nombre}`
                                        : option.producto_nombre
                                }
                                placeholder="Seleccionar"
                            />
                        )}
                    />
                    {formErrors.orden_produccion_pacas_secadora && (
                        <small className="text-danger">
                            {
                                formErrors.orden_produccion_pacas_secadora
                                    .message
                            }
                        </small>
                    )}
                </div>

                <div className="formulario-field">
                    <label className="text-nowrap">
                        Especifique cantidad aprox.
                    </label>
                    <NumberField
                        control={formControl}
                        name="cantidad_pacas_secadora"
                        errors={formErrors}
                        allowNegative={false}
                        placeholder="0"
                        rules={{
                            required:
                                "Debe especificar la cantidad de pacas",
                            min: {
                                value: 1,
                                message:
                                    "La cantidad de pacas debe ser mayor a 0",
                            },
                        }}
                        decimalScale={0}
                    />
                </div>

                <div className="formulario-field">
                    <div className="formulario-field">
                        <label className="text-nowrap">
                            Peso de cantidad aprox. de pacas en secadora
                        </label>
                        <RenderKilogramo
                            className="form-control disabled-input"
                            value={pesoPacasSecadora}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
